import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {FileUploader} from 'ng2-file-upload';
import {Microsite} from '../model/microsite';
import {ProjectService} from '../project/project.service';
import {Constants} from '../model/constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Uploader} from '../model/Uploader';
import {Project} from '../model/project';
import {Questionnaire} from '../model/questionnaire';
import {Terminal} from '../model/terminal';
import {TerminalUtil} from '../util/terminalUtil';
import {MaterialChipsInputComponent} from '../project/tags/materialChipsInput.component';
import {ContentPreviewComponent} from '../project/emailPreview/content-preview.component';
import {GenericModalComponent} from '../modal/generic-modal.component';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ValidationService} from '../service/validation-service';
import {TSMap} from 'typescript-map';
import {MediaQuestion} from '../model/media-question';

@Component({

  selector: 'microsite-configurator',
  template: `
    <ng-container *ngIf="microsite!=null">
      <div class="card">
      <div class="card-header subHeader">
        <h6><span><img class="titleBar" src="../../../assets/images/005.png"></span>Microsite Banners</h6>
      </div>
      <div class="card-body">
        <input type="file" class="form-control" name="single" ng2FileSelect [uploader]="uploader"
               (onFileSelected)="onFileSelected($event)"/>
        <br/>
        <table class="table">
          <thead class="thead-dark">
          <tr>
            <th>Uploaded File</th>
            <th>Size</th>
            <th>Placement</th>
            <th>Action</th>
            <th>Display Order</th>
          </tr>
          </thead>
              <tr *ngFor="let item of microsite.micrositeBannerContent.values()">
                <td><strong>{{ item.bannerName}}</strong></td>
                <td>{{item.size / 1024 / 1024 | number:'.2' }} MB</td>
                <td>
                  <div>
                    <div class="btn-group">
                      <button style="width:140px;" type="button"
                              class="btn btn-outline-primary">{{microsite.getBannerPosition(item.bannerName)}}</button>
                      <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                              aria-haspopup="true" aria-expanded="false">
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" (click)="microsite.onBannerPositionChanged(item.bannerName,'Top')">Top</a>
                        <a class="dropdown-item" (click)="microsite.onBannerPositionChanged(item.bannerName,'Above Content')">Above Content</a>
                        <a class="dropdown-item" (click)="microsite.onBannerPositionChanged(item.bannerName,'Below Content')">Below Content</a>
                        <a class="dropdown-item" (click)="microsite.onBannerPositionChanged(item.bannerName,'Bottom')">Bottom</a>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <button type="button" class="btn btn-danger btn-sm" (click)="removeBannerFromUploaderQueue(item.bannerName)">Remove</button>
                </td>
                <td>
                  <input type="number" (focusout)="updateOrderOfDisplay($event,item.bannerName)"  [(ngModel)]="item.order_id">
                </td>
              </tr>
        </table>
      </div>
    </div>
    <br/>
      <div class="card">
      <div class="card-header subHeader">
        <h6><span><img class="titleBar" src="../../../assets/images/146.png"></span>Background</h6>
      </div>
        <div class="card-body">
          <div>
            <label for="solidColor">Solid Color</label><input id="solidColor" type="radio" [checked]="solidColor"
                                                              (click)="solidColorChoice()">
          </div>
          <div *ngIf="solidColor">
            <input style="width:100px;" type="color" class="form-control" [(ngModel)]="microsite.background">
          </div>
          <div>
            <label for="backgroundImage">Background Image</label><input id="backgroundImage" type="radio" [checked]="!solidColor"
                                                                        (click)="backImgChoice()">
          </div>
          <div class="backgroudSelection" *ngIf="!solidColor">
            <table class="backgroundSelector">
              <tr>
                <!--<td ><input class="bkgNameInput" type="text"  [(ngModel)]="microsite.background"></td><td></td>-->
                <div class="input-group mb-3 bkgNameInput">
                  <input type="text" class=" form-control"  [(ngModel)]="microsite.background"  aria-label="Background File" aria-describedby="button-addon2">
                  <div class="input-group-append">
                    <input type="file" class="bkgInputBtn form-control" name="single" ng2FileSelect [uploader]="uploader" (onFileSelected)="onBackgroundSelect($event)"/>
                  </div>
                </div>
              </tr>
            </table>
          </div>
        </div>
      </div>
    <br/>
      <div class="card">
      <div class="card-header subHeader">
            <h6><span><img class="titleBar" src="../../../assets/images/font-color-icon.png"></span>Font Style</h6>
      </div>
      <div class="card-body">
        <table>
          <thead>
          <th>Font Color</th>
          <th>Font Size</th>
          <th>Font Family</th>
          <th>Font Weight</th>
          </thead>
          <tbody>
            <tr>
                <td>
                  <input style="width:100px;" type="color" class="form-control" [(ngModel)]="microsite.fontColor">
                </td>
                <td>
                  <input style="width:100px;" type="number" min="10" max="100" [(ngModel)]="microsite.fontSize">
                </td>
                  <td>
                    <div class="btn-group">
                      <button  style="width:140px;" type="button" class="btn btn-outline-primary">{{microsite.fontFamily}}</button>
                      <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                              aria-haspopup="true" aria-expanded="false">
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" (click)="microsite.setFontFamily('Arial')">Arial</a>
                        <a class="dropdown-item" (click)="microsite.setFontFamily('Comic')">Comic</a>
                        <a class="dropdown-item" (click)="microsite.setFontFamily('Microsoft')">Microsoft</a>
                        <a class="dropdown-item" (click)="microsite.setFontFamily('ubuntu')">Ubuntu</a>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="btn-group">
                      <button  style="width:140px;" type="button" class="btn btn-outline-primary">{{microsite.fontWeight}}</button>
                      <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                              aria-haspopup="true" aria-expanded="false">
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" (click)="microsite.setFontWeight('Normal')">Normal</a>
                        <a class="dropdown-item" (click)="microsite.setFontWeight('Bold')">Bold</a>
                        <a class="dropdown-item" (click)="microsite.setFontWeight('Bolder')">Bolder</a>
                        <a class="dropdown-item" (click)="microsite.setFontWeight('Lighter')">Lighter</a>
                      </div>
                    </div>
                  </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </ng-container>
      <br/>
    <div class="card">
      <div class="card-header subHeader">
        <h6><span><img class="titleBar" src="../../assets/images/PhotoWGallery.png"></span>Media-Content</h6>
      </div>
      <div class="card col-md-12">
        <div class="card-body">
          <button data-toggle="collapse" href="#emailMediaContent" role="button" aria-expanded="false"
                  aria-controls="emailMediaContent" type="button" class="btn btn-info ">Manage Media Content
          </button>
          <div class="collapse" id="emailMediaContent">
            <button type="button" class="btn btn-success btn-sm" (click)="onEmailAddMediaContent()">
              <span><i class="fas fa-plus"></i></span>
            </button>
            <div class="card mb-0" *ngFor="let mediaKey of this.mediaContent.keys()">
              <div class="card-header collapsed" data-toggle="collapse" >
                <a class="btn btn-primary btn-sm" data-toggle="collapse" href="#{{mediaKey}}">
                  <h6>
                    Media Content
                  </h6>
                </a>
                <button id="btnRemoveAccordion" (click)="onEmailRemoveMediaContent(mediaKey)" type="button"
                        class="btn btn-outline-danger btn-sm">Remove
                </button>
              </div>
              <div id="{{mediaKey}}" class="innerCollapse collapse">
                <div class="card card-body">
                  <form [formGroup]=this.getMediaFormRef(mediaKey)>
                    <div class="form-group">
                      <label>Question Number</label>
                      <input type="text" formControlName="questionNo" class="form-control"/>
                      <!--<control-message [control]="this.getMediaFormRef(media.key).controls.questionNo"></control-message>-->
                    </div>
                    <div class="form-group">
                      <label>Choice Number</label>
                      <input type="text" formControlName="choiceNo" class="form-control"/>
                      <!--<control-message [control]="this.getMediaFormRef(media.key).controls.choiceNo"></control-message>-->
                    </div>
                    <div class="form-group">
                      <label>Identification attribute</label>
                      <input type="text" formControlName="uid" class="form-control"/>
                      <!--<control-message [control]="this.getMediaFormRef(media.key).controls.uid"></control-message>-->
                    </div>
                    <div class="form-group">
                      <div class="btn-group">
                        <button style="width:140px;" type="button"
                                class="btn btn-outline-primary form-control">
                          {{this.emailMediaForm.get(mediaKey)['controls'].type.value}}
                        </button>
                        <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a class="dropdown-item" (click)="setType('pictureQuestion',mediaKey)">Picture</a>
                          <a class="dropdown-item" (click)="setType('videoQuestion',mediaKey)">Vimeo</a>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Link To Url</label>
                      <input type="checkbox" formControlName="linkToUrl"/>
                    </div>
                    <div *ngIf="this.getMediaFormRef(mediaKey)['controls'].linkToUrl.value">
                      <label>Destination Url</label>
                      <input type="text" formControlName="shareLink" placeholder="eg:url to microsite"/>
                    </div>
                    <div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <div class="card">
      <div class="card-header subHeader">
        <h6><span><img alt="image" class="titleBar" src="../../assets/images/myDocuments.png"></span>Dynamic Content Share</h6>
      </div>
      <div class="card-body">
        <div class="ContentSection">
          <div class="mat-app-background basic-container">
            <input type="checkbox" id="one" name="vimeo" value="Vimeo" [checked]="isChecked('vimeo')" (click)="onCheck($event,'vimeo')">
            <label for="one">Vimeo</label><br>
            <input type="checkbox" id="two" name="pictures" value="Picture" [checked]="isChecked('picture')" (click)="onCheck($event,'picture')">
            <label for="two">Local Pictures</label><br>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <div class="card">
      <div class="card-header subHeader">
        <h6><span><img class="titleBar" src="../../../assets/images/Other-word-icon.png"></span>Textual Content</h6>
      </div>
      <div class="card-body">
      <div class="ContentSection">
        <div class="mat-app-background basic-container">
          <div class="card-header subHeader">
            <h6>Languages</h6>
          </div>
          <div>
          <table class="langTable">
            <tbody>
              <material-chips-input (reload)="setSelectedLanguage($event)">loading</material-chips-input>
              <p *ngIf="this.selectedLang==null || this.selectedLang.length===0" class="alert"><span class="exclamation"><i class="fas fa-exclamation-circle"></i></span>Define and select a language before creating your sms content.</p>
            </tbody>
          </table>
          </div>
        </div>
      <br/>
        <div class="card">
        <div class="card-header subHeader">
            <h6>Microsite Text Paragraph</h6>
        </div>
        <div>
          <textarea class="micrositeTextArea" rows="6" cols="50" [(ngModel)]="textBox" (focusout)="insertTextInto()" (focusin)="checkLanguageSelected()" placeholder="Type in your text/ Ecrivez votre message"></textarea>
        </div>
        </div>
      </div>
    </div>
      </div>
    <br/>
    <h4>Microsite Actions</h4>
    <div class="card col-md-12">
      <div class="card-body">
        <button type="button" class="btn btn-lg btn-primary col-md-2" style="margin-right: 10px;" (click)="saveMicrosite()">
          <span><i class="fas fa-save" data-toggle="tooltip" data-placement="top" title="Create Email"></i></span>
          Save Microsite
        </button>
        <button type="button" class="btn btn-lg btn-primary col-md-2" style="margin-right: 10px;"
                (click)="previewMicrosite()" data-toggle="tooltip" data-placement="top" title="Preview Email"><span><i
          class="far fa-eye"></i></span></button>
      </div>
    </div>
    <content-preview-dialog  [isEmail]="false" [title]="this.title" [langArr]="this.langArr" [terminal]="this.terminal" [questionnaire]="this.questionnaire"></content-preview-dialog>
    <generic-info-modal [hide]="_hideInfoModal" (OkClick)="onOk()"></generic-info-modal>
  `,
  styles:[`.backgroundSelector,.table{table-layout: fixed;} .micrositeTextArea{width:100%;} .backgroundSelector{margin-left: 20px;} table{width:100%;}
  .bkgNameInput{width:50%;}
  .cardForm{margin-top:30px;border-color:#19A9E5;}
  .subHeader{height:45px;background-color:rgb(13,174,235);color:#ffffff;}
   .titleBar{height:32px;margin-right:5px;}
  .langTable{margin-left:20px;margin-right:20px;}
  .alert{font-weight: bold;color: red;font-size: 15px;margin-left:-20px;}
  .exclamation{margin-right:5px;}
  .collapse{
    margin-top: 5px;
    border: 1px dashed #1c71ff;
  }
  .innerCollapse{margin-left: 5px;margin-right:5px;margin-bottom: 5px;}
  #btnRemoveAccordion{float:right;}`]
})

export class MicrositeConfiguratorComponent implements OnInit, AfterViewInit,OnChanges {

  constructor(private _projectService: ProjectService, constants: Constants, private _deviceService: DeviceDetectorService, private refElement: ElementRef,private _formBuilder:FormBuilder) {

    this.uploader = Uploader.getUploader();
  }

  @Input() project:Project;

  @Input() questionnaire:Questionnaire;

  @Input() terminal:Terminal;


  private  uploader:FileUploader;

  private microsite:Microsite;

  private solidColor = true;

  private textBox:string;

  private selectedLang:string;

  private langArr:string[];

  private mediaContent:TSMap<string, MediaQuestion> = new TSMap();

  private emailMediaForm:TSMap<string, FormGroup> =new TSMap();

  private title='Microsite Preview';

  @ViewChild(MaterialChipsInputComponent) private materialTagChips:MaterialChipsInputComponent;
  @ViewChild(ContentPreviewComponent) private contentPreviewer:ContentPreviewComponent;
  @ViewChild(GenericModalComponent) private genericModal:GenericModalComponent;
  private _hideInfoModal = true;

  ngOnChanges(changes:SimpleChanges): void {
    console.log('ng on change called.');
    this.loadMicrositeConfig();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

    console.log('ng after view init called.');
   /*this.loadMicrositeConfig();*/
  }

  private loadMicrositeConfig() {
    this._projectService.getMicrositeConfig(this.project.id,this.terminal.associatedQuestionnaireId,this.terminal.id,TerminalUtil.getTerminalTypeId(this.terminal.type)).subscribe((microsite:string)=> {
      if(microsite.length>0) {
        this.microsite = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(JSON.parse(microsite),Microsite);// new Microsite(JSON.parse(microsite));
        if(this.microsite instanceof Microsite) {
          console.log(true);
        }
        this.setValidLanguages();
        this.selectedLang = this.langArr[0];
        this.solidColor = !this.microsite.background.includes('.jpg');
        this.materialTagChips.setLanguageArray(this.langArr);
        this.textBox = this.microsite.getMessage(this.selectedLang);
        this.materialTagChips.setSelectedLanguage(this.selectedLang);
        this.materialTagChips.setId(this.selectedLang);
        this.prepareSubSections();
      } else {
        this.microsite = new Microsite();
        this.materialTagChips.resetLanguageArray();
        this.textBox = '';
        this.langArr.length = 0;
      }
    });
  }

  private prepareSubSections() {
    let x = 0;
    for(const media of this.microsite.mediaQuestion) {
      this.emailMediaForm.set('media' + x, this.getMediaForm());
      this.mediaContent.set('media' + x, new MediaQuestion('',0));

      this.emailMediaForm.get('media' + x)['controls'].questionNo.setValue(media.questionNo);
      this.emailMediaForm.get('media' + x)['controls'].choiceNo.setValue(media.choiceNo);
      this.emailMediaForm.get('media' + x)['controls'].type.setValue(media.type);
      this.emailMediaForm.get('media' + x)['controls'].uid.setValue(media.uid);
      this.emailMediaForm.get('media' + x)['controls'].linkToUrl.setValue(media.linkToUrl);
      this.emailMediaForm.get('media' + x)['controls'].shareLink.setValue(media.externalLink.links.get(this.selectedLang));
      // this.emailMediaForm.get('media' + x)['controls'].imageHeight.setValue(media.externalLink.links.get(this.selectedLang));
      x++;
    }
  }


  private setValidLanguages() {
    if(this.microsite.texts.length === 0) {
      return;
    }
    this.langArr = this.microsite.texts[0].message.texts.keys();
  }

  backImgChoice() {
    this.solidColor = false;
    // this.backgroundImage = true;
  }

  solidColorChoice() {
    // this.backgroundImage = false;
    this.solidColor = true;

    this.microsite.background='#000000';
  }

  removeBannerFromUploaderQueue(file: string):void {
    console.log(file);
    for(const fic of this.uploader.queue) {
      if(fic.file.name === file) {
        this.uploader.removeFromQueue(fic);
      }
    }
    this._projectService.removeUploadedFile(file).then(
      (msg) => {
        console.log(msg);
      })
      .catch();
    this.microsite.removeBannerFromMicrositeBannerContent(file);
  }

  private saveMicrosite() {
    this.setMediaQuestionToMicrosite();
      this._projectService.configureMicrosite(this.project.id,this.terminal.associatedQuestionnaireId,this.terminal.id,TerminalUtil.getTerminalTypeId(this.terminal.type),JSON.stringify(this.microsite)).subscribe((next:any) => {
            console.log('HTTP Status: -> ' +next);
            if(next === 'OK') {
              this.genericModal.defineModal('Microsite configuration has been saved!', 'Microsite Configurator', 200);
              this._hideInfoModal = false;
            }
      });
  }

  private setMediaQuestionToMicrosite() {
    let found = false;
    for(const key of this.emailMediaForm.keys()) {
      let emailImage;
      if(this.microsite.mediaQuestion.find(m => m.uid === this.emailMediaForm.get(key)['controls'].uid.value)) {
        emailImage = this.microsite.mediaQuestion.find(m => m.uid === this.emailMediaForm.get(key)['controls'].uid.value);
        found = true;
      } else {
        emailImage = new MediaQuestion('',1);
      }

      emailImage.questionNo = this.emailMediaForm.get(key)['controls'].questionNo.value;
      emailImage.choiceNo = this.emailMediaForm.get(key)['controls'].choiceNo.value;
      emailImage.linkToUrl = this.emailMediaForm.get(key)['controls'].linkToUrl.value;
      emailImage.uid = this.emailMediaForm.get(key)['controls'].uid.value;
      emailImage.type = this.emailMediaForm.get(key)['controls'].type.value;
      // emailImage.imageHeight = this.emailMediaForm.get(key)['controls'].imageHeight.value;
      emailImage.externalLink.links.set(this.selectedLang,this.emailMediaForm.get(key)['controls'].shareLink.value);
      if(!found) {
        this.microsite.mediaQuestion.push(emailImage);
      }
      found = false;
    }
  }

  // this method is called everytime a file is selected
  onFileSelected(fic: File[]) {
    this.microsite.onBannerSelected(fic);
  }

  onBackgroundSelect(bgFic:File[]) {
    for(const fic of bgFic) {
      this.microsite.background = fic.name;
    }
  }

  insertTextInto() {
    this.microsite.setMessage(this.selectedLang,this.textBox);
  }

  setSelectedLanguage($event: string) {
    this.selectedLang = $event;
    this.textBox = this.microsite.getMessage(this.selectedLang);
  }

  updateOrderOfDisplay(event:any,fileName:string) {
    this.microsite.micrositeBannerContent.get(fileName).order_id = event.target.value;
  }

  checkLanguageSelected() {
    if(this.selectedLang === undefined) {
      this.genericModal.defineModal('You must instantiate an select a language!','Microsite Configurator',250);
      this._hideInfoModal = false;
    }
  }

  previewMicrosite() {
    this.contentPreviewer.showDialog();
  }

  onOk() {
    this._hideInfoModal = true;
  }

  //////

  getMediaForm() {
    return this._formBuilder.group(
        {
          questionNo:['',ValidationService.questionAndChoiceValidation],
          choiceNo:['',ValidationService.questionAndChoiceValidation],
          type:['',Validators.pattern('/\\w+')],
          uid:['',Validators.maxLength(12)],
          linkToUrl:[false,null],
          shareLink:[],
          imageWidth:['',Validators.pattern('/\\d+')],
          imageHeight:['',Validators.pattern('/\\d+')],
        }
    );

  }

  onEmailAddMediaContent() {
    let index;
    index = this.mediaContent.size();
    this.emailMediaForm.set('media'+index,this.getMediaForm());
    this.mediaContent.set('media'+index, new MediaQuestion('',1));
  }

  onEmailRemoveMediaContent(key: string) {
    this.mediaContent.delete(key);
    this.emailMediaForm.delete(key);

    let idx;

    for(const img of this.microsite.blockImages) {
      if(img.uid === key) {
        idx = this.microsite.blockImages.indexOf(img);
      }
    }
    this.microsite.blockImages.splice(idx,1);
  }

  getMediaFormRef(key:string):FormGroup {
    return this.emailMediaForm.get(key);
  }

  onCheck($event: any,value:string) {
    if($event.target.checked) {
      if(value === 'vimeo') {
        this.microsite.dynamicContentSharing.push('vimeo');
      } else if(value === 'picture') {
        this.microsite.dynamicContentSharing.push('picture');
      }
    }
    if(!$event.target.checked) {
      if(value === 'vimeo') {
        const idx = this.microsite.dynamicContentSharing.indexOf('vimeo');
        this.microsite.dynamicContentSharing.splice(idx,1);
      } else if(value === 'picture') {
        const idx = this.microsite.dynamicContentSharing.indexOf('picture');
        this.microsite.dynamicContentSharing.splice(idx,1);
      }
    }
  }

  isChecked(val:string) {
    if(this.microsite!=null && this.microsite.dynamicContentSharing.includes(val)) {
      return true;
    }
    return false;
  }

  setType(val: string,key:string) {
    this.emailMediaForm.get(key)['controls'].type.setValue(val);
  }
}
